<template>
	<v-bottom-sheet
		v-model="sheet"
		scrollable
		persistent
		no-click-animation
		:overlay-opacity="0.7"
		content-class="bottom-sheet">
		<v-card>
			<SheetHeader :title="title" @sheetClose="$emit('sheetClose')"/>
			<v-card-text  class="sheet-body mt-1">
				<v-form class="form-item" v-model="valid">
					<label class="label">탈퇴 사유</label>
					<div class="input-group mb-25">
						<v-select
							:items="reasonItems"
							item-value="cd"
							item-text="cdNm"
							v-model="selectedCd"
							required
							label="탈퇴 사유를 선택하세요"
							solo
							filled
							single-line
							background-color="#F7F7F7"/>
					</div>

					<div class="input-group mb-25" v-if="this.selectedCd==='07'">
						<v-text-field solo flat filled v-model="reasonTxt" required placeholder="탈퇴사유를 입력해주세요" />
					</div>
				</v-form>
			</v-card-text>
			<v-card-actions class="sheet-footer">
				<BlackBtn :str="title+'하기'" :disabled="this.selectedCd == ''" @click="doSecession"></BlackBtn>
			</v-card-actions>
		</v-card>
	</v-bottom-sheet>
</template>
<script>
import SheetHeader from "./SheetHeader";
import BlackBtn from "@/components/btns/BlackBtn";
import store from "@/store";
import {mixinAuth} from "@/mixins";
export default {
	props:{
		sheet:Boolean,
		flag:Number,
    title:String
	},
	data: ()=> ({
		valid: false,
		disabled: true,
		selectItem:'',
		reasonItems: [],
		selectedCd:'',
		reasonTxt:''
	}),
  mixins: [mixinAuth],
	components:{
		SheetHeader,
		BlackBtn
	},
	created() {
		this.getCodeList();
	},
	methods: {
		async doSecession() {

			this.$confirm(`정말로 ${this.title}하시겠습니까?`, {
				persistent: false,
				showClose: true,
				actions: {
				false: {text: '취소'},
				true: {text: '확인'}
				}
			}).then(result => {
				if (result) {

					let doSetData = {
						atvtYn: this.memberGb === '01' ? '06' : '03'
						,ctg:this.selectedCd
						,pnshReason:this.reasonTxt
						,userKey:store.getters.userKey
					};

					store.dispatch('setMemberSecession', this.$_payload('inData',doSetData))
						.then(res => {

							if (res.success) {
								this.$root.$children[0].$refs.toast.toastOpen('top',`${this.title}이(가) 완료되었습니다.`)
								store.dispatch('logout')
							}
						}).catch(error => {
							console.error(error);
						}).finally(() => {
						})
				}
			})
		},
		async getCodeList () {
			await store.dispatch('getCodeList', this.$_payload({'cdGrp': 'CT007'}))
				.then(res => {
					if (res.success) {

						this.reasonItems = res.data;
					} else {
						console.log(res.msg)
						this.reasonItems = [];
					}
				})
				.catch(error => {
					console.error(error)
					this.reasonItems = [];
				})
				.finally(() => {})
		},
	}
}
</script>
<style lang="scss" scoped>
::v-deep .v-select__selections {
	font-size: 14px;
}
.checkbox-circle-black::v-deep {
	.v-input__slot {
		align-items: flex-start;
	}
	.v-label {
		font-size: 14px;
		color: #818181;
		font-weight: 500;
		word-break: keep-all;
	}
}
</style>
